export interface IRecentCashAdvanceData {
  transactions: ITransaction[]
}

export interface IRepaymentMethod {
  fundId: number
  lastFourDigit: string
  logo: string
  methodName: string
  type: string
}

export interface ITransaction {
  id: string
  createdAt: string
  amount: number
  tipAmount: number
  feeAmount: number
  successful: boolean
  expectedDisbursementDate: string
  disbursementType: string
  collectionAt: string
  unpaidAmount: number
  unpaidPrincipal: number
  accountLastFour: string
  applicationSource: string
  applicationStatus: string
  type: string
  expectedProcessedDate: string
  paymentStatus: string
}

export interface IRepaymentFundOptionsData {
  funds: IRepaymentFundOptionFund[]
}

export interface IRepaymentFundOptionFund {
  available?: boolean
  fundId: number
  methodName: string
  lastFourDigit: string
  type: string
  expiryDate: string
  logo: string
  hasProductOption: boolean
  bankName: string
}

export enum RepaymentMethodType {
  ROAR_MONEY = 'DEMAND_DEPOSIT_ACCOUNT',
  DEBIT_CARD = 'DEBIT_CARD',
}

export interface OnboardingQualification {
  isQualified: boolean
  qualificationRulesBreakdown: {
    instacashAddOnSubscribed: boolean
    activeCBPlusMembership: boolean
    activeWowMembership: boolean
    deactivatedWowMembership: boolean
    passedLoanUnderwriting: boolean
    hasActiveDDInRM: boolean
    experiment: {
      icTrial: boolean
      switchedDDToRM: boolean
      isBVLessIC: boolean
      otherExperiments: boolean
    }
  }
}

export interface OnboardingQualificationResponse {
  data: OnboardingQualification
}

export interface IInstacashTncEsignDocuments {
  esignDocuments: IInstacashTncEsignDocument[]
}

export enum InstacashEsignDocumentStatus {
  PENDING = 'PENDING',
  SIGNED = 'SIGNED',
}
export interface IInstacashTncEsignDocument {
  documentId: string
  documentName: string
  status: InstacashEsignDocumentStatus
  signedAt: string
}

export type IEligibilityBankStatus = 'COMPLETE' | 'UNLINKED' | 'REMOVED'

/** To Revisit:
 * 1. Only institutionProviderId can be null.
 * 2. Others would always return its type
 */
export interface IInstacashEligibilityBVAccount {
  accountLastFour: string | null
  accountNumber: string | null
  bankName: string | null
  bankStatus: IEligibilityBankStatus
  institutionProviderId: number | null
  isExternalAccount: boolean
  logo: string | null
  userId: string | null
}

export interface IInstacashTimeZone {
  userStateAddress: string | null
  userTimeZone: string | null
}

export enum ICDateFormat {
  ABBR_MONTH_DAY_YEAR = 'MMM D, YYYY',
  ABBR_MONTH_DAY = 'MMM D',
  WEEKDAY_ABBR_MONTH_DAY_YEAR = 'ddd, MMM D, YYYY',
  YEAR_MONTH_DAY_WITH_DASH = 'YYYY-MM-DD',
}

export enum ICOutstandingCycleStatus {
  UNPAID = 'UNPAID',
  OPEN = 'OPEN',
}

interface PayableItem {
  id: string | null
  amount: number
  unpaidAmount: number
}

export interface ApplicationItem {
  id: string
  disbursementStatus: 'NONE' | 'PENDING' | 'SUCCESS' | 'FAILED'
  disbursementType:
    | 'EXTERNAL_DEBIT_CARD'
    | 'ACH'
    | 'ROAR_MONEY'
    | 'DELAYED_ROAR_MONEY'
    | 'RTP'
    | 'ADD_NEW_DEBIT_CARD'
    | ''

  cashAdvance: PayableItem | null
  tip: PayableItem | null
  fee: PayableItem | null
  amount: number
  unpaidAmount: number
  payableAmount: number
  createdAt: string
}

export interface CashAdvanceCycleItem {
  collectionDate: string
  applications: ApplicationItem[]
  status: ICOutstandingCycleStatus
  totalAmount: number
  totalUnpaidAmount: number
  payableAmount: number
}

export interface IOutstandingCashAdvance {
  cashAdvanceCycles: CashAdvanceCycleItem[]
  totalAmount: number
  totalUnpaidAmount: number
  totalPendingPaidAmount: number
  payableAmount: number
}

export interface IInstacashDemandDepositRepayment {
  paidAmount: number
  paymentStatus: string
}

export interface IInstacashDebitCardRepayment {
  paidAmount: number
  paymentStatus: string
}

export interface IInstacashUpdateTargetBVAccountReq {
  bank: {
    accountNumber: string | null
    bankName: string
  }
  identifier: string // account last four
  source: 'IC_SELF_SERVICE'
}
